<div class="console_modal">
    <div class="modal-header">
        <h5 class="modal-title">Profilo utente</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
    </div>

    <div class="modal-body">
        <div class="container-fluid">
            <form #customerForm="ngForm" novalidate (ngSubmit)="saveIban()">
                <div class="row mb-4">
                    <div class="col-6">
                        <label for="customerName" class="form-label">Nome</label>
                        <input
                            disabled
                            name="customerName"
                            type="text"
                            class="form-control"
                            id="customerName"
                            [value]="customerInfo?.firstName"
                        />
                    </div>
                    <div class="col-6">
                        <label for="customerSurname" class="form-label">Cognome</label>
                        <input
                            disabled
                            name="customerSurname"
                            type="text"
                            class="form-control"
                            id="customerSurname"
                            [value]="customerInfo?.lastName"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label for="customerType" class="form-label">Codice fiscale</label>
                        <input
                            disabled
                            name="customerTaxCode"
                            type="text"
                            class="form-control"
                            id="customerTaxCode"
                            [value]="customerInfo?.fiscalCode"
                        />
                    </div>
                    <div class="col-6">
                        <label for="customerIban" class="form-label">IBAN</label>
                        <input
                            name="customerIban"
                            type="text"
                            required
                            class="form-control"
                            id="customerIban"
                            placeholder="Inserisci l'IBAN"
                            pattern="^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}$"
                            [(ngModel)]="customerInfo.iban"
                            #customerIban="ngModel"
                            [class.is-invalid]="customerIban?.invalid && customerForm.submitted"
                        />
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div class="modal-footer d-flex justify-content-around">
        <button type="button" class="btn btn-outline-primary" (click)="activeModal.close()"><i class="fa-solid fa-arrow-left" aria-hidden="true"></i> Annulla</button>
        <button type="button" class="btn btn-primary" (click)="customerForm.onSubmit($event)"><i class="fa-solid fa-check" aria-hidden="true"></i> Salva</button>
    </div>
</div>
